module.exports = __webpack_public_path__ + "static/media/bg-violet.26de97e9.jpg";